import { createFileRoute, redirect } from '@tanstack/react-router';

import { taskQueryOptions } from '@/features/board/api';

/** TSK-10: the permanent link of a task opens its project with the task selected. */
export const Route = createFileRoute('/_app/t/$key')({
  loader: async ({ context, params }) => {
    const task = await context.queryClient.query({ ...taskQueryOptions(params.key), staleTime: 0 });
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router's redirect API
    throw redirect({
      to: '/projects/$projectId',
      params: { projectId: task.project.id },
      search: { task: task.key },
      replace: true,
    });
  },
});
